import React, {Component, ReactElement} from 'react'
import {
    ContentsSubTitleInner,
    ContentsSubTitleWrapper,
    MainContainer,
    ParagraphText,
} from '../../../styledComponents/ContentsArea'
import {DisplayBlockDiv} from '../../../styledComponents/DisplayItem'
import {PrimaryStyledButton} from '../../../styledComponents/Button'
import {StyledDiv} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {Location} from 'react-router-dom'

interface Props {
    location: Location
}

class NatResidentChangePasswordCompletePage extends Component<Props & ResidentPagePropsSet> {

    constructor(props: Props & ResidentPagePropsSet) {
        super(props)
        this.personalSettingButtonClick = this.personalSettingButtonClick.bind(this)
    }

    // 個人設定ページに戻る
    personalSettingButtonClick(): void {
        this.props.navigate(
            `/resident/personalSetting`,
        )
    };

    render(): ReactElement {
        return (
            <>
                <ContentsSubTitleWrapper>
                    <ContentsSubTitleInner>
                        パスワード変更(完了)
                    </ContentsSubTitleInner>
                </ContentsSubTitleWrapper>
                <MainContainer>
                    <MessageBlock>
                        <Message>
                            パスワードの変更を完了しました。
                        </Message>
                    </MessageBlock>
                    <DisplayBlockDiv>
                        <PrimaryStyledButton
                            onClick={this.personalSettingButtonClick}>
                            個人設定ページに戻る
                        </PrimaryStyledButton>
                    </DisplayBlockDiv>
                </MainContainer>
            </>
        )
    }
}

export default createResidentPage(NatResidentChangePasswordCompletePage)

// メッセージブロック
const MessageBlock: StyledDiv = styled.div`
  text-align: center;
`
// メッセージ
const Message = styled(ParagraphText)`
  display: inline-block;
  text-align: left;
`
